// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PrimaryButtonAnimation_primary-btn-animation__cvcf2 {
  width: 3rem;
  height: 3rem;
  border-radius: 0.5rem;
  background-color: #fff;
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: center;
}

.PrimaryButtonAnimation_primary-btn-animation__gif__zzA2g {
  transform: rotate(90deg);
  width: 80%;
  height: 80%;
}
`, "",{"version":3,"sources":["webpack://./src/components/UI/PrimaryButton/PrimaryButtonAnimation/PrimaryButtonAnimation.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,WAAW;AACb","sourcesContent":[".primary-btn-animation {\n  width: 3rem;\n  height: 3rem;\n  border-radius: 0.5rem;\n  background-color: #fff;\n  display: flex;\n  flex-flow: row wrap;\n  align-items: center;\n  justify-content: center;\n}\n\n.primary-btn-animation__gif {\n  transform: rotate(90deg);\n  width: 80%;\n  height: 80%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary-btn-animation": `PrimaryButtonAnimation_primary-btn-animation__cvcf2`,
	"primary-btn-animation__gif": `PrimaryButtonAnimation_primary-btn-animation__gif__zzA2g`
};
export default ___CSS_LOADER_EXPORT___;
